import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import IconCheck from "@mui/icons-material/Check";
import IconDownload from "@mui/icons-material/CloudDownload";
import IconMenu from "@mui/icons-material/MoreVert";
import IconPrint from "@mui/icons-material/Print";
import IconColumns from "@mui/icons-material/ViewColumn";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import { Fragment, useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./appDataTable.css";
// import DownloadExcelDataTable from "./downloadExcel";
import { translate } from "../../app/utils";
import DownloadPDFDataTable from "./downloadPDF";

const AppDataTable = ({
  data = [],
  columns = [],
  searchPlaceholder = translate("search"),
  actions = null,
  action = null,
  rowsPerPageOptions = [25, 100, 250],
  emptyMessage = translate("noDataFound"),
  id,
  downloadFileName = "List",
  hasBackground = true,
  dateFrom = null,
  dateTo = null,
  actionIcon = null,
  ...attrs
}) => {
  const [filteredData, setFilteredData] = useState(data);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[0]);
  const [isOpenActions, setIsOpenActions] = useState(() => {
    let _initState = [];
    data.forEach(() => {
      _initState.push(false);
    });
    return _initState;
  });

  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [isShowingDownloadPopper, setIsShowingDownloadPopper] = useState(false);

  const [selectedSearchColumn, setSelectedSearchColumn] = useState("ALL");
  const [searchColumnOptions, setSearchColumnOptions] = useState([]);

  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  const [columnsVisibility, setColumnsVisibility] = useState(() => {
    let _temp = [];
    columns.forEach((c) => {
      if ((c.options ?? {}).visible ?? true) {
        _temp.push(true);
      } else {
        _temp.push(false);
      }
    });
    return _temp;
  });

  const [isShowingVisibleColumnsPopper, setIsShowingVisibleColumnsPopper] =
    useState(false);

  const [visibleColumns, setVisibleColumns] = useState(() => {
    let _visibleColumns = [];
    columns.forEach((c) => {
      if ((c.options ?? {}).visible ?? true) {
        _visibleColumns.push(c);
      }
    });
    return _visibleColumns;
  });

  const [isOpenPDFViewer, setIsOpenPDFViewer] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredData(data);
    } else {
      let _list = [];
      data.forEach((item) => {
        let _matchFound = false;
        if (selectedSearchColumn === "ALL") {
          columns.forEach((col) => {
            if (
              (item[col.name] ?? "")
                .toString()
                .toLowerCase()
                .replaceAll(",", "")
                .includes(searchQuery.toLowerCase().replaceAll(",", "")) &&
              !_matchFound
            ) {
              _list.push(item);
              _matchFound = true;
            }
          });
        } else {
          if (
            (item[selectedSearchColumn] ?? "")
              .toString()
              .toLowerCase()
              .replaceAll(",", "")
              .includes(searchQuery.toLowerCase().replaceAll(",", "")) &&
            !_matchFound
          ) {
            _list.push(item);
            _matchFound = true;
          }
        }
      });
      setFilteredData(_list);
      setCurrentPageNo(1);
    }
  }, [searchQuery, data, columns, selectedSearchColumn]);

  useEffect(() => {
    let _options = [
      {
        display: translate("allColumns"),
        value: "ALL",
      },
    ];

    visibleColumns.forEach((c) => {
      _options.push({
        display: c.label,
        value: c.name,
      });
    });

    setSearchColumnOptions(_options);
    setSelectedSearchColumn("ALL");
  }, [visibleColumns]);

  useEffect(() => {
    if (sortColumn != null) {
      sortData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortColumn, sortOrder]);

  const doPrint = () => {
    navigate("/print", {
      state: {
        data: filteredData,
        columns: visibleColumns,
        title: downloadFileName,
        dateFrom: dateFrom,
        dateTo: dateTo,
      },
    });
  };

  const compare = (a, b) => {
    if (
      a[`${visibleColumns[sortColumn].name}`] <
      b[`${visibleColumns[sortColumn].name}`]
    ) {
      return -1;
    }
    if (
      a[`${visibleColumns[sortColumn].name}`] >
      b[`${visibleColumns[sortColumn].name}`]
    ) {
      return 1;
    }
    return 0;
  };

  const getColumnSortMarkerVisibility = (column) => {
    if (sortColumn !== null) {
      if (visibleColumns[sortColumn].name === column.name) {
        return "sort-marker-visible";
      } else {
        return "";
      }
    } else return "";
  };

  const handleColumnSort = (index) => {
    if (sortColumn === index) {
      reverseSortOrder();
    } else {
      setSortColumn(index);
    }
  };

  const reverseSortOrder = () => {
    if (sortOrder === "asc") {
      setSortOrder("desc");
    } else {
      setSortOrder("asc");
    }
  };

  const sortData = () => {
    let _sortedData = [...filteredData];
    _sortedData.sort(compare);
    if (sortOrder === "desc") {
      _sortedData = _sortedData.reverse();
    }
    setFilteredData(_sortedData);
  };

  const handleClickVisibleColumnItem = (index) => {
    let _columnsVisibility = [...columnsVisibility];

    let _countChecked = 0;
    columnsVisibility.forEach((i) => {
      if (i === true) {
        _countChecked++;
      }
    });

    if (
      _columnsVisibility[index] === false ||
      (_countChecked > 1 && _columnsVisibility[index] === true)
    ) {
      _columnsVisibility[index] = !_columnsVisibility[index];

      let _visibleColumns = [];
      columns.forEach((col, _index) => {
        if (_columnsVisibility[_index] === true) {
          _visibleColumns.push(col);
        }
      });

      setSortColumn(null);
      setVisibleColumns(_visibleColumns);
      setColumnsVisibility(_columnsVisibility);
    }
  };

  const BuildTableTopBar = () => {
    return (
      <div className="table-top-bar">
        <div className="left">
          <TextField
            id={`search-input-${id}`}
            variant="outlined"
            fullWidth
            margin="dense"
            value={searchQuery}
            placeholder={searchPlaceholder}
            onChange={(e) => setSearchQuery(e.target.value)}
          />

          <TextField
            id={`search-column-select-${id}`}
            className="ml-5 w-180"
            variant="outlined"
            fullWidth
            select
            margin="dense"
            value={selectedSearchColumn}
            onChange={(e) => setSelectedSearchColumn(e.target.value)}
          >
            {searchColumnOptions.map((option) => (
              <MenuItem
                id={`search-column-menu-item-${option.value}`}
                key={option.value}
                value={option.value}
              >
                {option.display}
              </MenuItem>
            ))}
          </TextField>
        </div>

        <div className="right">
          <Tooltip title={translate("visibleColumns")} placement="top">
            <IconButton
              className="action-button"
              id={`action-btn-visible-columns-${id}`}
              onClick={() => setIsShowingVisibleColumnsPopper(true)}
            >
              <IconColumns color="secondary" />
            </IconButton>
          </Tooltip>

          <Tooltip title={translate("download")} placement="top">
            <IconButton
              className="action-button"
              id={`action-btn-download-${id}`}
              onClick={() => setIsShowingDownloadPopper(true)}
            >
              <IconDownload color="secondary" />
            </IconButton>
          </Tooltip>

          <Tooltip title={translate("print")} placement="top">
            <IconButton
              className="action-button"
              id={`action-btn-print-${id}`}
              onClick={doPrint}
            >
              <IconPrint color="secondary" />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    );
  };

  const BuildHeader = () => {
    return (
      <thead>
        <tr key="tr-header">
          {visibleColumns.map((column, index) => (
            <th
              key={`th-col-${index}`}
              className={
                "text-align-" +
                (column.hasOwnProperty("options")
                  ? column.options.align ?? "left"
                  : "left")
              }
            >
              <span>
                {column.label ?? ""}
                <div
                  className={`sort-marker ${getColumnSortMarkerVisibility(
                    column
                  )}`}
                  id={`sort-marker-${column.name}`}
                  onClick={() => handleColumnSort(index)}
                >
                  {sortOrder === "asc" ? (
                    <ArrowUpwardIcon className={"icon"} />
                  ) : (
                    <ArrowDownwardIcon className={"icon"} />
                  )}
                </div>
              </span>
            </th>
          ))}
          {(actions != null || action != null) && (
            <th className="td-action">Action</th>
          )}
        </tr>
      </thead>
    );
  };

  const BuildActions = (index, _item) => {
    if (actions != null) {
      return (
        <td key={`td-action-index`} className="td-action">
          <IconButton
            className="action-menu-icon"
            onClick={(e) => {
              e.preventDefault();
              let _initState = [];
              filteredData.forEach(() => _initState.push(false));
              _initState[index] = true;
              setIsOpenActions(_initState);
            }}
          >
            <IconMenu className="icon" />
          </IconButton>
          {isOpenActions[index] && (
            <div key={`actions-popper-${index}`} className="actions-popper">
              <ClickAwayListener
                key={`clickaway-listener-${index}`}
                onClickAway={() => {
                  let _initState = [];
                  filteredData.forEach(() => _initState.push(false));
                  setIsOpenActions(_initState);
                }}
              >
                <MenuList id={`menu-list-${index}`}>
                  {actions.map((action, _index) => {
                    let { renderCheck } = action;
                    let render = true;
                    if (renderCheck) render = renderCheck(_item);
                    if (render) {
                      return (
                        <MenuItem
                          key={`action-menu-item-${_index}`}
                          role="appbar-menu_item"
                          id={`action-menu-item-${_index}`}
                          onClick={(e) => {
                            e.preventDefault();
                            action.onClick(_item);
                            let _initState = [];
                            filteredData.forEach(() => _initState.push(false));
                            setIsOpenActions(_initState);
                          }}
                        >
                          {action.action}
                        </MenuItem>
                      );
                    } else return <></>;
                  })}
                </MenuList>
              </ClickAwayListener>
            </div>
          )}
        </td>
      );
    } else if (action != null) {
      return (
        <td key={`td-action-index`} className="td-action">
          <div className="flex-row justify-content-center">
            <Tooltip placement="top" title={action[0].action}>
              <IconButton
                className="action-menu-icon"
                id={`action-menu-item-${index}`}
                onClick={(e) => {
                  e.preventDefault();
                  action[0].onClick(_item);
                }}
              >
                {actionIcon}
              </IconButton>
            </Tooltip>
          </div>
        </td>
      );
    } else return <></>;
  };

  const BuildBody = () => {
    return (
      <tbody>
        {filteredData
          .slice(
            (currentPageNo - 1) * rowsPerPage,
            (currentPageNo - 1) * rowsPerPage + rowsPerPage
          )
          .map((item, index) => (
            <Fragment key={`frag-${index}`}>
              <tr key={`tr-item-${index}`}>
                {visibleColumns.map((col, _index) => (
                  <td
                    key={`td-row-${index}-col-${_index}`}
                    className={
                      "text-align-" +
                      (col.hasOwnProperty("options")
                        ? col.options.align ?? "left"
                        : "left")
                    }
                  >
                    {item[col.name] ?? ""}
                  </td>
                ))}
                {BuildActions(index, item)}
              </tr>
              <tr key={`tr-divider-${index}`}>
                <td
                  key={`td-divider-${index}`}
                  colSpan={
                    actions !== null || action !== null
                      ? visibleColumns.length + 1
                      : visibleColumns.length
                  }
                >
                  <div key={`tr-td-divider-${index}`} className="divider"></div>
                </td>
              </tr>
            </Fragment>
          ))}
      </tbody>
    );
  };

  const BuildTableFooter = () => {
    return (
      <div className="table-footer">
        <div className="left">
          <div className="flex-box">
            {filteredData.length} {translate("itemTotal")}
            {filteredData.length > 0 && (
              <>
                {" "}
                | {translate("page")} {currentPageNo} {translate("of")}{" "}
                {Math.ceil(filteredData.length / rowsPerPage)}
              </>
            )}
          </div>

          {filteredData.length > 0 && (
            <div className="flex-box">
              <div>{translate("show")}</div>
              <TextField
                select
                variant="outlined"
                margin="dense"
                value={rowsPerPage}
                onChange={(e) => {
                  setCurrentPageNo(1);
                  setRowsPerPage(e.target.value);
                }}
              >
                {rowsPerPageOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
              <div>{translate("rows")}</div>
            </div>
          )}
        </div>

        <div className="right">
          <Tooltip title={translate("firstPage")} placement="top">
            <span>
              <button
                disabled={currentPageNo === 1}
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentPageNo(1);
                }}
              >
                {"<<"}
              </button>
            </span>
          </Tooltip>

          <Tooltip title={translate("previousPage")} placement="top">
            <span>
              <button
                disabled={currentPageNo === 1}
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentPageNo(currentPageNo - 1);
                }}
              >
                {"<"}
              </button>
            </span>
          </Tooltip>

          <Tooltip title={translate("nextPage")} placement="top">
            <span>
              <button
                disabled={
                  currentPageNo >= Math.ceil(filteredData.length / rowsPerPage)
                }
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentPageNo(currentPageNo + 1);
                }}
              >
                {">"}
              </button>
            </span>
          </Tooltip>

          <Tooltip title={translate("lastPage")} placement="top">
            <span>
              <button
                disabled={
                  currentPageNo >= Math.ceil(filteredData.length / rowsPerPage)
                }
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentPageNo(
                    Math.ceil(filteredData.length / rowsPerPage)
                  );
                }}
              >
                {">>"}
              </button>
            </span>
          </Tooltip>
        </div>
      </div>
    );
  };

  return (
    <>
      <div
        className={`app-data-table ${
          hasBackground ? "app-data-table-box-shadow" : ""
        }`}
        id={id}
        {...attrs}
      >
        {BuildTableTopBar()}
        {filteredData.length > 0 ? (
          <div className="table-wrapper">
            <table>
              {BuildHeader()}
              {BuildBody()}
            </table>
          </div>
        ) : (
          <div className="empty-message-container">{emptyMessage}</div>
        )}
        {BuildTableFooter()}
      </div>

      {isOpenPDFViewer && (
        <DownloadPDFDataTable
          isOpen={isOpenPDFViewer}
          data={filteredData}
          columns={visibleColumns}
          title={downloadFileName}
          dateFrom={dateFrom}
          dateTo={dateTo}
          onClose={() => setIsOpenPDFViewer(false)}
        />
      )}

      {isShowingVisibleColumnsPopper && (
        <div className="visible-columns-popper">
          <ClickAwayListener
            onClickAway={() => setIsShowingVisibleColumnsPopper(false)}
          >
            <MenuList>
              {columns.map((col, index) => (
                <MenuItem
                  key={`visible-col-menu-item-${index}`}
                  id={`visible-col-menu-item-${index}`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleClickVisibleColumnItem(index);
                  }}
                >
                  <IconCheck
                    className={
                      columnsVisibility[index]
                        ? "visible-col-menu-item-checked"
                        : "visible-col-menu-item-unchecked"
                    }
                  />
                  {col.label}
                </MenuItem>
              ))}
            </MenuList>
          </ClickAwayListener>
        </div>
      )}

      {isShowingDownloadPopper && (
        <div className="download-popper">
          <ClickAwayListener
            onClickAway={() => setIsShowingDownloadPopper(false)}
          >
            <MenuList>
              <MenuItem onClick={() => setIsOpenPDFViewer(true)}>
                {translate("downloadPDF")}
              </MenuItem>
              {/* You can add Excel download menu item here if needed */}
            </MenuList>
          </ClickAwayListener>
        </div>
      )}
    </>
  );
};

export default AppDataTable;
